export default function() {
	'ngInject';

	return function(text) {
		return text.replace(/\'/g, '\\\'');
	};
};
